
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.333 2V.667a.666.666 0 111.334 0V2a.666.666 0 11-1.334 0zm-8 .667A.666.666 0 004 2V.667a.666.666 0 10-1.333 0V2c0 .368.298.667.666.667zM12 11.333v-2h-.667V12h2v-.667H12zm-3.333.334c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3zm7.333 0a4.333 4.333 0 11-8.666 0 4.333 4.333 0 018.666 0zM6.509 14H1.333V5.333H14V6.51c.485.22.933.504 1.333.845v-6.02h-2V2c0 .877-.852 1.56-1.772 1.263-.554-.179-.894-.741-.894-1.323v-.607h-6V2c0 .877-.852 1.56-1.772 1.263C2.34 3.084 2 2.522 2 1.94v-.607H0v14h7.354c-.34-.4-.625-.848-.845-1.333z","fill":"#3F51B5"}})])
          )
        }
      }
    